import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { FaBox, FaVial, FaShieldAlt, FaEnvelopeOpenText, FaHeartbeat } from "react-icons/fa";
import i18n from 'i18next'

class CommentTestezSonMicrobiote extends Component {
    render() {
        const { t } = this.props;
        const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined

        return (
            <Container fluid className="bg-image-main py-5">
                <Container className="px-3 px-md-5">
                    <h2 className="main-title h2-override text-center mb-4 shadow-text pb-md-5">
                        {t("testmicro|Comment tester son microbiote avec Nahibu ?")}
                    </h2>
                    <Row>
                        {/* Col gauche */}
                        <Col xs={12} md={7} className="mb-4 mb-md-0 shadow-text">
                            <p className="h2-override-3 white text-shadow pb-3 pt-4 underline">
                                <span style={{lineHeight: "1.5"}}>{t("testmicro|testmicro-text-intro")}</span>
                            </p>
                            <ol className="white pl-0 pl-md-5 h3-override-2">
                                {[
                                    { icon: <FaBox className="mr-2 mt-1 icon-fix fix-icon-taille" />, text: t("testmicro|testmicro-text-1") },
                                    { icon: <FaVial className="mr-2 mt-1 icon-fix fix-icon-taille" />, text: t("testmicro|testmicro-text-2") },
                                    { icon: <FaShieldAlt className="mr-2 mt-1 icon-fix fix-icon-taille" />, text: t("testmicro|testmicro-text-3") },
                                    { icon: <FaEnvelopeOpenText className="mr-2 mt-1 icon-fix fix-icon-taille" />, text: t("testmicro|testmicro-text-4") },
                                ].map((step, i) => (
                                    <li key={i} className="d-flex align-items-start mb-3">
                                        {step.icon}
                                        <span className="mr-2 font-weight-bold">{i + 1}.</span>
                                        {step.text}
                                    </li>
                                ))}
                            </ol>

                            <div className="h3-override-1 white text-shadow pt-4 text-center text-md-left">
                                <span>{t("testmicro|Un geste simple, pour un impact profond sur votre santé.")}</span>
                                <FaHeartbeat className="ml-2 mt-2 icon-fix fix-icon-taille" />
                            </div>
                        </Col>

                        {/* Col droite */}
                        <Col xs={12} md={5} className="pl-0 pl-md-5">
                            <div style={{ maxWidth: '400px', margin: '0 auto' }}>
                                {(() => {
                                    let iframeUrl = "";

                                    switch (language) {
                                        case "fr":
                                            iframeUrl = "https://sibforms.com/serve/MUIFAFr_psUtn_tOe1zKWCcmhkf-bMgAe9TjbJ9pjKG9kFxuLZmYw4Nme1ScdTZx7lGF-RnhPg4SFcDhWPSJettG-eZPBatRJJ1TD9VGJHH5pD3_Wdn4AfOieC9qdRKP1DIZRRzOufP6tEE4iNv7Q5hIxcRQnQxZn1Wg3HeH8ble7s9eNzRa-0vlXHRc9sLDYc-oB_n7ZiXFnnxw";
                                            break;
                                        case "en":
                                            iframeUrl = "https://sibforms.com/serve/MUIFALdnfMbYcZVh9-T8slr9VfuqDaiiBJjUMcHQd-UrDl-0g-tXhHF8ENweY1k1VymqCBQA4JUb7FANEAteJ65WI6eTxGGmtWKdMtUIr05w6au5Pe9y_8O-8K8rbZ_cIIOnQYHTL0dhpLy1z1CN43JRQl6HkDU8-ie9CVl92tZfUZvyv1yxZhws20HNVgJG78PYIio5mBi-219l";
                                            break;
                                        case "es":
                                            iframeUrl = "https://sibforms.com/serve/MUIFAJYVYc_d1uwp2CIi73dyZmpAS4t95fl1KbgYCFuLKWYbTYgvgpy63AdiKwBdLYeAY5l5rbmlY3n5e-NMRW7hBwfyah5LYbKoNkYHA2HtI8qC5jvaBVYKzurTvpmm_ZpBD5o4m-2V2NS5OCHaSgNudTFzw9i0nyQ0CP8M_zoe83N7ovpzbUxoU8zWve0V1uLd32tCxC5qoIs-";
                                            break;
                                        default:
                                            iframeUrl = "https://sibforms.com/serve/MUIFAFr_psUtn_tOe1zKWCcmhkf-bMgAe9TjbJ9pjKG9kFxuLZmYw4Nme1ScdTZx7lGF-RnhPg4SFcDhWPSJettG-eZPBatRJJ1TD9VGJHH5pD3_Wdn4AfOieC9qdRKP1DIZRRzOufP6tEE4iNv7Q5hIxcRQnQxZn1Wg3HeH8ble7s9eNzRa-0vlXHRc9sLDYc-oB_n7ZiXFnnxw"; // fallback FR
                                    }

                                    return (
                                        <iframe
                                            className="embed-responsive-item"
                                            title={t("testmicro|Testez votre microbiote intestinal")}
                                            src={iframeUrl}
                                            allowFullScreen
                                            style={{
                                                width: "100%",
                                                height: "380px",
                                                border: "none",
                                                borderRadius: "10px",
                                                overflow: "hidden"
                                            }}
                                        />
                                    );
                                })()}
                            </div>
                        </Col>

                    </Row>
                </Container>
            </Container>
        )
    }
}

export default withTranslation()(CommentTestezSonMicrobiote)
